export const SET_SHOW_MAIN_NOTIFICATIONS = 'SET_SHOW_MAIN_NOTIFICATIONS';

export const setShowMainNotification = (status) => {
  return {
    type: SET_SHOW_MAIN_NOTIFICATIONS,
    status,
  };
};
